import { z } from "zod";

import { providerIntegrationProviderSchema } from "./providerIdentity";

export const externalThreadMappingSchema = z.object({
  enterpriseId: z.string(),
  provider: providerIntegrationProviderSchema,
  providerTaskId: z.string(),
  providerTaskUrl: z.string().optional(),
  providerProjectId: z.string().optional(),
  linkedChatId: z.string().optional(),
  linkedProjectId: z.string().optional(),
  botProviderUserId: z.string().optional(),
  inboundCommentIds: z.array(z.string()).optional(),
  outboundCommentIds: z.array(z.string()).optional(),
  linkedAt: z.date().optional(),
  linkedBy: z.string().optional(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type ExternalThreadMapping = z.infer<typeof externalThreadMappingSchema>;
